// src/logger/Logger.ts
var Logger = class _Logger {
  config;
  logLevels = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3
  };
  constructor(config = {}) {
    this.config = {
      enableInTest: false,
      enableInProduction: true,
      prefix: "",
      minLevel: "debug",
      debugInProduction: false,
      ...config
    };
  }
  shouldLog(level) {
    const nodeEnv = typeof process !== "undefined" ? process.env.NODE_ENV : "production";
    const isDevelopment = nodeEnv === "development";
    const isTest = nodeEnv === "test";
    const isProduction = nodeEnv === "production";
    if (this.logLevels[level] < this.logLevels[this.config.minLevel]) {
      return false;
    }
    if (isTest) {
      return this.config.enableInTest;
    }
    if (isProduction) {
      if (level === "debug" && !this.config.debugInProduction) {
        return false;
      }
      return this.config.enableInProduction;
    }
    return isDevelopment || !(isTest || isProduction);
  }
  formatMessage(level, message, ...args) {
    const timestamp = (/* @__PURE__ */ new Date()).toISOString();
    const prefix = this.config.prefix ? `[${this.config.prefix}] ` : "";
    const levelPrefix = `[${level.toUpperCase()}] `;
    const formattedMessage = `${timestamp} ${levelPrefix}${prefix}${message}`;
    return [formattedMessage, ...args];
  }
  debug(message, ...args) {
    if (this.shouldLog("debug")) {
      console.log(...this.formatMessage("debug", message, ...args));
    }
  }
  info(message, ...args) {
    if (this.shouldLog("info")) {
      console.info(...this.formatMessage("info", message, ...args));
    }
  }
  warn(message, ...args) {
    if (this.shouldLog("warn")) {
      console.warn(...this.formatMessage("warn", message, ...args));
    }
  }
  error(message, ...args) {
    if (this.shouldLog("error")) {
      console.error(...this.formatMessage("error", message, ...args));
    }
  }
  createChild(prefix, config) {
    const childPrefix = this.config.prefix ? `${this.config.prefix}:${prefix}` : prefix;
    return new _Logger({
      ...this.config,
      ...config,
      prefix: childPrefix
    });
  }
};
var createLogger = (config) => {
  return new Logger(config);
};
var defaultLogger = createLogger();

export {
  Logger,
  createLogger,
  defaultLogger
};
//# sourceMappingURL=chunk-R2PM4C72.js.map